import { Actions } from '@ngrx/effects';
import { AppState } from '@_store/index.reducers';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CompanyCommunicationLeadTodoApiService } from '@_services/api/company-communication-lead-todo-api.service';
import { GeneratedCompanyCommunicationLeadTodoEffects } from './company-communication-lead-todo-generated.effects';

@Injectable()
export class CompanyCommunicationLeadTodoEffects extends GeneratedCompanyCommunicationLeadTodoEffects {
  constructor(
    actions$: Actions,
    companyCommunicationLeadTodoApiService: CompanyCommunicationLeadTodoApiService,
    store$: Store<AppState>
  ) {
    super(actions$, companyCommunicationLeadTodoApiService, store$);
  }
}
